<template>
  <div>
    <div class="container-xl">
      <div class="top">
        <div class="logo">
          <router-link to="/"
            ><img src="../img/branogo2x.png" alt=""
          /></router-link>
          <h3 @click="jump">be@me主页</h3>
          <!-- <div class="head-2">
            <h3>語言</h3>
            <div>
              <el-button type="text" @click="dialogTableVisible = true"
                ><img class="head-tou-img" src="../img/香港.png" alt="" />
              </el-button>

              <el-dialog
                :append-to-body="true"
                :visible.sync="dialogTableVisible"
              >
                <div class="head-tou-1-en">
                  <p>請選擇你的語言</p>
                  <div class="head-tou-1-0">
                    <router-link to="/sign">
                      <img class="head-tou-1-1" src="../img/香港.png" alt="" />
                      <div class="head-tou-1-div">&nbsp;中國香港特別行政區</div>
                      <div class="head-tou-1-div">
                        &nbsp;繁體中文
                      </div></router-link
                    >
                  </div>
                  <div class="head-tou-1-0 English">
                    <router-link to="/zh-en/signen">
                      <img class="head-tou-1-2" src="../img/香港.png" alt="" />
                      <div class="head-tou-2-div">
                        &nbsp;Hong Kong S.A.R. of China
                      </div>
                      <div class="head-tou-2-div">
                        &nbsp;Hong Kong English
                      </div></router-link
                    >
                  </div>
                </div>
              </el-dialog>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Member",
  data() {
    return {
      visible: false,
      dialogTableVisible: false,
    };
  },
  methods:{
    jump(){
      this.$router.push("/");
    }
  }
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.top {
  width: 100%;
  padding: 5px 0;
  background: #00e467;
}
.logo {
  display: flex;
  align-items: center;
}
.logo > a {
  margin-left: 5%;
}
.logo > a > img {
  width: 28px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.logo > h3 {
  width: 80%;
  font-weight: 700;
  font-size: 21px;
  margin: 0;
  cursor:pointer
}
.head-2 {
  float: right;
  display: flex;
  align-items: center;
}
.head-2 > div {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.head-2 > h3 {
  margin: 5px 5px 0 0;
  font-size: 19px;
  font-weight: 700;
}
.head-tou-img {
  width: 35px;
  margin-top: 2px;
}
.el-button {
  padding: 0;
}
.head-tou-1-en {
  height: 180px;
  margin: 0 auto;
}
.head-tou-1-en > p {
  font-size: 32px;
  text-align: center;
  margin-bottom: 30px;
}
.head-tou-1-0 {
  width: 50%;
  height: 70px;
  float: left;
  padding: 5px 5px;
  border-radius: 10px;
}
.head-tou-1-0 > a {
  color: #323e48 !important;
}
.head-tou-1-0:hover {
  -webkit-box-shadow: 0px 0px 10px grey;
  box-shadow: 0px 0px 10px grey;
  -moz-box-shadow: 0px 0px 10px grey;
  -o-box-shadow: 0px 0px 10px grey;
}
.head-tou-1-1 {
  width: 60px;
  height: 60px;
  float: left;
}
.head-tou-1-div {
  margin-top: 9px;
  color: #323e48 !important;
}
.head-tou-1-2 {
  width: 60px;
  height: 60px;
  float: left;
}
.head-tou-2-div {
  margin-top: 9px;
  color: #323e48 !important;
}

@media all and (max-width: 992px) {
  .logo > h3 {
    width: 70%;
  }
}
@media all and (max-width: 570px) {
  .logo > h3 {
    width: 60%;
    font-size: 19px;
  }
  .head-tou-1-en {
    height: 280px;
  }
  .English {
    float: left;
    margin-top: 35px;
  }
  .head-tou-1-0 {
    width: 100%;
  }
  .head-tou-1-en > p{
    font-size: 27px;
  }
}
</style>
